  export default function TruncatedText({ text, limit }) {
        if (text&&text.length <= limit) {
          return <span>{text}</span>;
        }
        return (
          <span>{`${text&&text.substring(
            0,
            limit
          )}`}</span>
        );
      }